import React from 'react'

const LoaderOverlay = ({ bgColor }: any) => {
    return (
        <div className='d-flex w-100 justify-content-center align-items-center' style={{
            height: "100%",
            zIndex: "100",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: bgColor ? bgColor : 'rgb(245,248,250)', opacity: '0.7',
            overflow: 'hidden'
        }}>
            <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-grow spinner-border-md align-middle ms-2'>
                </span>
            </span>
        </div>
    )
}

export default LoaderOverlay